import React, { Component } from 'react'
import Ink from 'react-ink';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class ConfigurationModalStepButton extends Component {
  constructor(props) {    
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap(e) {
    e.preventDefault();
    if (this.props.callback) {
      this.props.callback(this.props.id);
    }
  }

  render() {
    let icon = 'icon circle thin';
    if (this.props.stepValues.length > 0) {
      icon = 'icon check circle';
    }

    const isDisabled = !this.props.callback;

    return (
  <button 
    className="configurationModalStepButton" 
    onClick={this.handleTouchTap}
    disabled={isDisabled}
  >
    <div className="configurationModalStepButtonRow">
      <div className="configurationModalStepButtonCheck">
        <i className={icon}>&nbsp;</i>
      </div>
      <div className="configurationModalStepButtonLabels">
        <label className="stepName">{this.props.stepDescription}</label>
        {
          this.props.stepValues.map(value => 
            <label key={value.ArticleConfigurationStepValueId} className="stepValue">{value.Description}<br/></label>
          )
        }
      </div>
    </div>
    <Ink />
  </button>
    )
  }
}

ConfigurationModalStepButton.propTypes = {
  id: PropTypes.number,
  stepDescription: PropTypes.string,
  stepValues: PropTypes.array,
  callback: PropTypes.func
}
function mapStateToProps(state) {
  return {
    steps: state.generalState.modal.configurationModal.configurationSteps,
  }
}

export default connect(mapStateToProps, { })(ConfigurationModalStepButton)



// WEBPACK FOOTER //
// src/components/ConfigurationModalStepButton.jsx